import {IController} from "angular";
import {ManualImportServiceName, ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {ManualImportService} from "../services/ManualImportService";
import {ImportReportLogFilter} from "../../opportunities_filter/model/OpportunityFilterUi";
import './manual-import.scss';
import {Pageable} from "../../utils/models/Page";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {ReportLog} from "../model/ReportLog";
import {TriggeredBy} from "../model/TriggeredBy";


export class ManualImportController implements IController {

    public static instance = [ManualImportServiceName, ToastNotificationServiceName, ManualImportController];

    private pageable: Pageable;

    private filter: ImportReportLogFilter;

    private showLoading: boolean;

    private fundedLogs: ReportLog[];

    constructor(private manualImportService: ManualImportService,
                private toastNotficationService: ToastNotificationService) {
        this.pageable = {
            page: 1, pageSize: 10, totalElements: 0, fetchPage: this.onPaging
        };
    }

    private onPaging = () => {
        this.onFilterValueChange(this.filter);
    };

    private onFilterValueChange = (filter: ImportReportLogFilter) => {
        this.showLoading = true;
        this.filter = filter;
        this.filter.triggeredBy = TriggeredBy.MANUAL;
        this.filter.fetchPersistedCustomers = false;
        this.filter.fetchRunning = true;
        let pageNuber = this.pageable.page - 1;
        let pageSize = this.pageable.pageSize;
        this.manualImportService.getLogs(pageNuber, pageSize, filter)
            .then(resp => {
                this.showLoading = false;
                if (resp.status == 200) {
                    this.handleNewLogsPage(resp);
                } else {
                    this.toastNotficationService.generateErrorMessage("Failed to fetch funded logs.");
                }
            })
    };

    private handleNewLogsPage(resp) {
        let logsPage = resp.data;
        this.fundedLogs = logsPage.content;
        this.pageable.totalElements = logsPage.totalElements;
        this.pageable.page = logsPage.number + 1;
        this.pageable.pageSize = logsPage.size;
    }
}